export default {
  GUIDES_FETCH_START: 'GUIDES_FETCH_START',
  GUIDES_FETCH_SUCCESS: 'GUIDES_FETCH_SUCCESS',
  GUIDES_FETCH_FAILURE: 'GUIDES_FETCH_FAILURE',

  GUIDE_TOGGLE: 'GUIDE_TOGGLE',
  GUIDES_TOGGLE_ALL: 'GUIDES_TOGGLE_ALL',
}
